"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSearchPreviewProduct = exports.searchPreviewProductContext = exports.SearchPreviewProductProvider = void 0;
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
const searchPreviewProductContext = exports.searchPreviewProductContext = /*#__PURE__*/(0, _react.createContext)({
  code: '',
  name: '',
  searchPhrase: '',
  responsive: true
});
const SearchPreviewProductProvider = ({
  value,
  children
}) => /*#__PURE__*/(0, _jsxRuntime.jsx)(searchPreviewProductContext.Provider, {
  value: value,
  children: children
});
exports.SearchPreviewProductProvider = SearchPreviewProductProvider;
const useSearchPreviewProduct = () => (0, _react.useContext)(searchPreviewProductContext);
exports.useSearchPreviewProduct = useSearchPreviewProduct;
//# sourceMappingURL=searchPreviewProductContext.js.map